import type { IntakeRecord } from '../../store/slices/intakeSlice';

export const AUTHORIZATION_VISIT_COUNT_FIELDS = [
  { key: 'sn_visits', label: 'SN Visits' },
  { key: 'pt_visits', label: 'PT Visits' },
  { key: 'ot_visits', label: 'OT Visits' },
  { key: 'st_visits', label: 'ST Visits' },
  { key: 'msw_visits', label: 'MSW Visits' },
  { key: 'hha_visits', label: 'HHA Visits' },
  { key: 'dietician_visits', label: 'Dietician Visits' },
  { key: 'misc_visits', label: 'Misc Visits' },
] as const;

export type AuthorizationVisitCountKey =
  (typeof AUTHORIZATION_VISIT_COUNT_FIELDS)[number]['key'];

export type AuthorizationVisitCounts = Partial<
  Record<AuthorizationVisitCountKey, number | null | undefined>
>;

export function isAuthorizationDraftValid(
  visitCounts: AuthorizationVisitCounts | null | undefined
): boolean {
  if (!visitCounts) return true;

  return AUTHORIZATION_VISIT_COUNT_FIELDS.every(({ key }) => {
    const value = visitCounts[key];
    return value == null || (Number.isInteger(value) && value >= 0);
  });
}

export function intakeAuthorizationVisitCounts(
  intake: Pick<IntakeRecord, AuthorizationVisitCountKey>
): AuthorizationVisitCounts {
  return Object.fromEntries(
    AUTHORIZATION_VISIT_COUNT_FIELDS.map(({ key }) => [key, intake[key]])
  ) as AuthorizationVisitCounts;
}
